<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="4">
                    <ValidationProvider name="company_id" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('coop_company')">
                            <coop-company-selectbox v-model="formData.company_id" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="semester_id" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox v-model="formData.semester_id" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="name" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('coop_event_name')">
                            <b-form-input v-model="formData.name" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="type" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('coop_event_type')">
                            <parameter-selectbox code="coop_event.types" v-model="formData.type" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="event_date" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('date')">
                            <SelectDate v-model="formData.event_date" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="start_time" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('start_time')">
                            <b-form-input v-model="formData.start_time" type="time" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="end_time" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('end_time')">
                            <b-form-input v-model="formData.end_time" type="time" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="application_start_date" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('application_start_date')">
                            <SelectDate v-model="formData.application_start_date" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="application_end_date" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('application_end_date')">
                            <SelectDate v-model="formData.application_end_date" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="quota" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('coop_quota')">
                            <b-form-input v-model="formData.quota" type="number" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="format" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('coop_event_format')">
                            <parameter-selectbox code="coop_event.formats" v-model="formData.format" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="status" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox code="coop_event.statuses" v-model="formData.status" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('faculty')">
                        <faculty-selectbox v-model="formData.faculty_code" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('department')">
                        <department-selectbox :faculty_code="formData.faculty_code" v-model="formData.department_code" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('class')">
                        <classes-selectbox v-model="formData.class" />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="detail" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('detail')">
                            <b-form-textarea v-model="formData.detail" rows="4" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" :disabled="formLoading" @click="save" class="mr-2">
                    {{ $t('save') }}
                </b-button>
                <b-button variant="light" @click="$emit('cancel')">
                    {{ $t('cancel') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import FacultySelectbox from '@/components/interactive-fields/FacultySelectbox.vue';
    import DepartmentSelectbox from '@/components/interactive-fields/DepartmentSelectbox';
    import ClassesSelectbox from '@/components/interactive-fields/ClassesSelectbox';
    import SemestersSelectbox from '@/components/interactive-fields/SemestersSelectbox';
    import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';
    import CoopCompanySelectbox from '@/components/interactive-fields/CoopCompanySelectbox.vue';
    import SelectDate from '@/components/interactive-fields/SelectDate';
    import CoopEventService from '@/services/CoopEventService';

    export default {
        components: {
            ValidationObserver,
            ValidationProvider,
            FacultySelectbox,
            DepartmentSelectbox,
            ClassesSelectbox,
            SemestersSelectbox,
            ParameterSelectbox,
            CoopCompanySelectbox,
            SelectDate
        },
        props: {
            eventData: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                formLoading: false,
                formData: {
                    id: null,
                    company_id: null,
                    semester_id: null,
                    name: null,
                    type: null,
                    event_date: null,
                    start_time: null,
                    end_time: null,
                    application_start_date: null,
                    application_end_date: null,
                    quota: null,
                    format: null,
                    faculty_code: null,
                    department_code: null,
                    class: null,
                    detail: null,
                    status: null
                }
            };
        },
        created() {
            if (this.eventData) {
                this.formData = { ...this.formData, ...this.eventData };
            }
        },
        methods: {
            async save() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (!isValid) return;

                this.formLoading = true;
                const serviceMethod = this.formData.id
                    ? CoopEventService.update(this.formData.id, this.formData)
                    : CoopEventService.store(this.formData);

                serviceMethod
                    .then((response) => {
                        this.$toast.success(this.$t('api.' + (response.data.message || 'success')));
                        this.$emit('actionSuccess');
                    })
                    .catch((error) => {
                        this.showErrors(error, this.$refs.formModalValidate);
                    })
                    .finally(() => {
                        this.formLoading = false;
                    });
            }
        }
    };
</script>
